export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  tags: string[];
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '星辰变',
    author: '我吃西红柿',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20xianxia%20manhua%20cover%20featuring%20a%20young%20cultivator%20with%20flowing%20robes%20standing%20under%20a%20starry%20night%20sky%20with%20glowing%20celestial%20energy%20swirling%20around%20him%2C%20mystical%20mountains%20in%20background%2C%20vibrant%20warm%20golden%20and%20crimson%20tones%2C%20clean%20composition%20on%20soft%20cream%20background%2C%20manhua%20art%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一名普通少年意外获得星辰之力传承，从此踏上修真之路。在浩瀚宇宙中，他历经无数磨难，从弱小的凡人一步步成长为掌控星辰的绝世强者。绚丽的法术对决、宏大的世界观设定，带你领略波澜壮阔的修真世界。',
    status: '连载中',
    rating: 9.5,
    views: 12800000,
    chapters: [
      { id: 1, title: '第1话 星落凡尘', updateDate: '2026-08-01' },
      { id: 2, title: '第2话 初入修真', updateDate: '2026-08-02' },
      { id: 3, title: '第3话 灵脉觉醒', updateDate: '2026-08-03' },
      { id: 4, title: '第4话 宗门考核', updateDate: '2026-08-04' },
      { id: 5, title: '第5话 星辰之力', updateDate: '2026-08-04' },
    ],
    tags: ['玄幻', '修真', '热血', '逆袭'],
    featured: true,
  },
  {
    id: 2,
    title: '末日求生录',
    author: '暗夜行者',
    category: 'kehuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20sci-fi%20manhua%20cover%20showing%20a%20survivor%20in%20worn%20combat%20gear%20holding%20a%20weapon%20amidst%20ruined%20cityscape%20with%20orange%20dusk%20sky%2C%20dramatic%20lighting%2C%20warm%20amber%20tones%2C%20clean%20composition%2C%20manhua%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '一场突如其来的病毒席卷全球，文明崩塌，秩序瓦解。幸存者们在废土之上艰难求生，面对变异生物和人性的考验。主角凭借超强的生存能力与智慧，在末日世界中建立新的人类据点。',
    status: '连载中',
    rating: 9.3,
    views: 9850000,
    chapters: [
      { id: 1, title: '第1话 病毒爆发', updateDate: '2026-07-28' },
      { id: 2, title: '第2话 废墟求生', updateDate: '2026-07-30' },
      { id: 3, title: '第3话 遭遇变异', updateDate: '2026-08-01' },
      { id: 4, title: '第4话 幸存者营地', updateDate: '2026-08-03' },
    ],
    tags: ['科幻', '末日', '生存', '冒险'],
    featured: true,
  },
  {
    id: 3,
    title: '甜蜜契约',
    author: '樱花漫社',
    category: 'lianai',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20manhua%20cover%20featuring%20a%20handsome%20male%20lead%20and%20a%20beautiful%20female%20lead%20standing%20back%20to%20back%20under%20cherry%20blossom%20trees%20with%20soft%20pink%20petals%20falling%2C%20warm%20gentle%20lighting%2C%20pastel%20warm%20tones%2C%20clean%20composition%2C%20shoujo%20manhua%20art%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '因为一份意外签订的契约，高冷总裁与普通女孩的命运紧紧绑在了一起。从最初的互相嫌弃到渐渐心动，一段甜蜜又搞笑的同居生活就此展开。当契约到期，他们还能坦然面对彼此的心意吗？',
    status: '连载中',
    rating: 9.1,
    views: 7650000,
    chapters: [
      { id: 1, title: '第1话 意外相遇', updateDate: '2026-07-25' },
      { id: 2, title: '第2话 契约签订', updateDate: '2026-07-27' },
      { id: 3, title: '第3话 同居生活', updateDate: '2026-07-30' },
      { id: 4, title: '第4话 心跳加速', updateDate: '2026-08-02' },
    ],
    tags: ['恋爱', '总裁', '契约', '甜宠'],
    featured: true,
  },
  {
    id: 4,
    title: '校园风云录',
    author: '青春绘梦',
    category: 'xiaoyuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20school-life%20manhua%20cover%20showing%20a%20group%20of%20teenage%20students%20in%20school%20uniforms%20laughing%20together%20on%20a%20sunny%20rooftop%20with%20blue%20sky%20and%20white%20clouds%2C%20bright%20warm%20sunlight%2C%20cheerful%20atmosphere%2C%20clean%20composition%2C%20youth%20manhua%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '转学生林枫来到星城一中，凭借过人的才华和幽默的性格迅速成为校园风云人物。在这里他结识了一群志同道合的朋友，一起经历考试、运动会、文艺汇演的青春岁月。热血与欢笑交织的校园故事！',
    status: '已完结',
    rating: 9.0,
    views: 6540000,
    chapters: [
      { id: 1, title: '第1话 转学第一天', updateDate: '2026-06-01' },
      { id: 2, title: '第2话 新朋友', updateDate: '2026-06-05' },
      { id: 3, title: '第3话 校园祭', updateDate: '2026-06-10' },
      { id: 4, title: '第4话 篮球对决', updateDate: '2026-06-15' },
      { id: 5, title: '第5话 毕业季（终）', updateDate: '2026-07-01' },
    ],
    tags: ['校园', '青春', '友情', '搞笑'],
    featured: true,
  },
  {
    id: 5,
    title: '暗夜侦探',
    author: '墨渊',
    category: 'xuanyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20manhua%20cover%20featuring%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20dimly%20lit%20alley%20with%20a%20magnifying%20glass%2C%20noir%20atmosphere%20with%20warm%20street%20lamp%20glow%2C%20suspenseful%20mood%2C%20clean%20composition%2C%20mystery%20manhua%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '城市中接连发生离奇案件，天才侦探沈夜凭借超凡的推理能力抽丝剥茧，揭开真相。每一个案件背后都隐藏着惊人的秘密，而所有的线索似乎都指向一个神秘组织。准备好跟随沈夜一起破案了吗？',
    status: '连载中',
    rating: 9.4,
    views: 5430000,
    chapters: [
      { id: 1, title: '第1话 午夜来电', updateDate: '2026-07-20' },
      { id: 2, title: '第2话 第一个现场', updateDate: '2026-07-23' },
      { id: 3, title: '第3话 蛛丝马迹', updateDate: '2026-07-27' },
    ],
    tags: ['悬疑', '推理', '侦探', '都市'],
  },
  {
    id: 6,
    title: '爆笑日常',
    author: '开心果工作室',
    category: 'gaoxiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20hilarious%20comedy%20manhua%20cover%20with%20exaggerated%20funny%20facial%20expressions%20of%20cartoon%20characters%20in%20everyday%20situations%2C%20bright%20playful%20colors%20with%20warm%20yellow%20and%20orange%20tones%2C%20clean%20composition%2C%20gag%20manhua%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '四个性格迥异的室友住在一起，每天都上演着令人捧腹大笑的故事。从外卖点错到洗衣机大战，从考试突击到约会翻车，每一话都让你笑得肚子疼。生活中的小确幸，就在这里！',
    status: '连载中',
    rating: 8.9,
    views: 4320000,
    chapters: [
      { id: 1, title: '第1话 新室友驾到', updateDate: '2026-07-15' },
      { id: 2, title: '第2话 谁动了我的外卖', updateDate: '2026-07-18' },
      { id: 3, title: '第3话 考前突击夜', updateDate: '2026-07-22' },
    ],
    tags: ['搞笑', '日常', '四格', '轻松'],
  },
  {
    id: 7,
    title: '烈焰战神',
    author: '火云邪神',
    category: 'rexue',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20battle%20shounen%20manhua%20cover%20showing%20a%20fierce%20warrior%20with%20flaming%20fists%20in%20combat%20pose%20against%20a%20backdrop%20of%20explosive%20fire%20and%20smoke%2C%20intense%20warm%20red%20and%20orange%20tones%2C%20clean%20composition%2C%20action%20manhua%20art%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '上古时期，烈焰战神陨落，其力量化为九枚火种散落人间。千年后，少年叶炎意外获得其中一枚，从此踏上收集火种、成为新一代烈焰战神的热血之路。酣畅淋漓的战斗，激情澎湃的冒险！',
    status: '连载中',
    rating: 9.6,
    views: 15600000,
    chapters: [
      { id: 1, title: '第1话 火种觉醒', updateDate: '2026-07-10' },
      { id: 2, title: '第2话 初次战斗', updateDate: '2026-07-13' },
      { id: 3, title: '第3话 炎之试炼', updateDate: '2026-07-17' },
      { id: 4, title: '第4话 劲敌登场', updateDate: '2026-07-22' },
      { id: 5, title: '第5话 烈焰初燃', updateDate: '2026-07-28' },
    ],
    tags: ['热血', '战斗', '冒险', '异能'],
    featured: true,
  },
  {
    id: 8,
    title: '都市异能录',
    author: '城市猎人',
    category: 'dushi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20superpower%20manhua%20cover%20featuring%20a%20young%20man%20in%20casual%20streetwear%20with%20electric%20energy%20crackling%20around%20his%20hands%20standing%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20clean%20composition%2C%20urban%20manhua%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '普通上班族李逸某天突然觉醒了异能，从此他的生活发生了翻天覆地的变化。在繁华都市的暗面，异能者们的较量从未停止。他必须学会掌控自己的力量，在平凡与非凡之间找到平衡。',
    status: '连载中',
    rating: 8.8,
    views: 3210000,
    chapters: [
      { id: 1, title: '第1话 平凡的一天', updateDate: '2026-08-01' },
      { id: 2, title: '第2话 异能初现', updateDate: '2026-08-02' },
      { id: 3, title: '第3话 暗流涌动', updateDate: '2026-08-03' },
    ],
    tags: ['都市', '异能', '战斗', '日常'],
  },
  {
    id: 9,
    title: '妖神记',
    author: '发飙的蜗牛',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20xianxia%20manhua%20cover%20showing%20a%20cultivator%20with%20a%20spirit%20beast%20companion%20surrounded%20by%20floating%20ancient%20runes%20and%20mystical%20energy%2C%20ethereal%20atmosphere%20with%20warm%20golden%20light%2C%20clean%20composition%2C%20cultivation%20manhua%20art%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '在一个人与妖兽共存的世界，少年聂离获得了一本神秘的妖神诀。他契约妖兽、修炼妖术，一步步揭开这个世界的终极秘密。华丽的妖兽战斗场面，精彩纷呈的修真冒险！',
    status: '连载中',
    rating: 9.2,
    views: 8900000,
    chapters: [
      { id: 1, title: '第1话 被遗忘的天才', updateDate: '2026-07-05' },
      { id: 2, title: '第2话 妖神诀', updateDate: '2026-07-08' },
      { id: 3, title: '第3话 契约妖兽', updateDate: '2026-07-12' },
      { id: 4, title: '第4话 初露锋芒', updateDate: '2026-07-18' },
    ],
    tags: ['玄幻', '修真', '妖兽', '冒险'],
    featured: true,
  },
  {
    id: 10,
    title: '恋爱方程式',
    author: '心动漫画',
    category: 'lianai',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20manhua%20cover%20showing%20a%20couple%20sharing%20earphones%20while%20studying%20together%20in%20a%20cozy%20library%20with%20warm%20afternoon%20sunlight%20streaming%20through%20windows%2C%20soft%20warm%20tones%2C%20clean%20composition%2C%20romance%20manhua%20art%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '学霸少女和学渣少年的奇妙邂逅，一份学习辅导协议拉近了他们的距离。在朝夕相处中，两个完全不同世界的人竟然产生了意想不到的化学反应。学霸教你谈恋爱，学渣也能逆袭人生！',
    status: '已完结',
    rating: 8.7,
    views: 4120000,
    chapters: [
      { id: 1, title: '第1话 年级第一', updateDate: '2026-05-01' },
      { id: 2, title: '第2话 学习小组', updateDate: '2026-05-08' },
      { id: 3, title: '第3话 图书馆密语', updateDate: '2026-05-15' },
      { id: 4, title: '第4话 心动瞬间', updateDate: '2026-05-22' },
    ],
    tags: ['恋爱', '校园', '甜宠', '治愈'],
  },
  {
    id: 11,
    title: '末世之刃',
    author: '夜雨声烦',
    category: 'kehuan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cyberpunk%20sci-fi%20manhua%20cover%20with%20a%20cyborg%20warrior%20wielding%20an%20energy%20blade%20in%20a%20neon-lit%20dystopian%20cityscape%2C%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20clean%20composition%2C%20sci-fi%20manhua%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '公元2150年，人工智能统治了世界。少数幸存的人类组成反抗军，主角身披机械外骨骼，手持能量之刃，带领同伴们向AI帝国发起最后的冲锋。人类文明的命运，掌握在他们手中。',
    status: '连载中',
    rating: 9.0,
    views: 5670000,
    chapters: [
      { id: 1, title: '第1话 机械纪元', updateDate: '2026-07-01' },
      { id: 2, title: '第2话 地下城', updateDate: '2026-07-05' },
      { id: 3, title: '第3话 反抗军', updateDate: '2026-07-10' },
    ],
    tags: ['科幻', '末世', '机甲', '战斗'],
  },
  {
    id: 12,
    title: '仙王的日常生活',
    author: '枯玄',
    category: 'gaoxiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedy%20cultivation%20manhua%20cover%20showing%20a%20powerful%20immortal%20cultivator%20in%20traditional%20robes%20doing%20everyday%20chores%20like%20cooking%20with%20spiritual%20energy%2C%20humorous%20contrast%2C%20warm%20and%20bright%20colors%2C%20clean%20composition%2C%20comedy%20manhua%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '修仙界最强仙王为了躲避无尽的工作，封印记忆跑到凡间上高中。本想低调生活，奈何实力不允许！随手一挥就能移山填海，打个喷嚏都能引发天地异象。最强仙王的平凡（？）日常开始了！',
    status: '连载中',
    rating: 9.7,
    views: 18900000,
    chapters: [
      { id: 1, title: '第1话 仙王降临', updateDate: '2026-06-15' },
      { id: 2, title: '第2话 高中生活', updateDate: '2026-06-18' },
      { id: 3, title: '第3话 低调太难', updateDate: '2026-06-22' },
      { id: 4, title: '第4话 修仙社团', updateDate: '2026-06-28' },
    ],
    tags: ['搞笑', '修仙', '校园', '日常'],
    featured: true,
  },
];

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((comic) => comic.id === id);
};

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((comic) => comic.category === slug);
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter((comic) => comic.featured);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => {
    const latestA = a.chapters[a.chapters.length - 1].updateDate;
    const latestB = b.chapters[b.chapters.length - 1].updateDate;
    return latestB.localeCompare(latestA);
  }).slice(0, limit);
};

export const getPopularComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};